import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useApplicationSize } from '../../../../providers/providers-application';
import { ReceiptModalContext } from '../../context/ReceiptModalContext';
import { ReceiptModal } from '../ReceiptModal/ReceiptModal';
export const ReceiptStickyOnMobile = ({ children, toggle, dataTest = 'receipt-modal-sticky-on-mobile', }) => {
    const applicationSize = useApplicationSize();
    const isSmall = applicationSize === 'small';
    const [isOpen, setIsOpen] = useState(false);
    return (_jsxs(ReceiptModalContext.Provider, { value: {
            isOpen: isSmall && isOpen,
            setIsOpen,
        }, children: [isSmall ? _jsx(ReceiptModal, { dataTest: dataTest, children: children }) : children, !isOpen && isSmall && toggle] }));
};
